// Asteroid Radar — a self-contained DOM arcade minigame played at the spaceport.
// Blips appear on a circular radar and fade fast; tap them before they vanish.
// Reach the target number of scans to win a radar crystal. Fully self-contained:
// mount() builds the overlay, unmount() tears it down. Styled by ui/space.css.

export class AsteroidRadar {
  constructor({ target = 10, duration = 30, onWin, onClose } = {}){
    this.target = target;
    this.duration = duration;
    this.onWin = onWin || (() => {});
    this.onClose = onClose || (() => {});
    this.hits = 0;
    this.timeLeft = duration;
    this.blips = new Set();
    this.spawnTimer = null;
    this.tickTimer = null;
    this.done = false;
  }

  mount(){
    const el = document.createElement('div');
    el.className = 'cafe-panel space-mg';
    el.innerHTML = `
      <div class="mg-card">
        <h2>📡 Asteroid Radar</h2>
        <div class="mg-sub">Tap the blips before they fade — scan <b>${this.target}</b> asteroids!</div>
        <div class="mg-stats"><span id="mgHits">0 / ${this.target}</span><span id="mgTime">${this.duration}s</span></div>
        <div class="radar" id="radar">
          <div class="radar-ring"></div><div class="radar-ring r2"></div>
          <div class="radar-sweep"></div>
        </div>
        <button class="cafe-btn ghost mg-quit">give up</button>
      </div>`;
    document.body.appendChild(el);
    this.el = el;
    this.radar = el.querySelector('#radar');
    this.hitsLabel = el.querySelector('#mgHits');
    this.timeLabel = el.querySelector('#mgTime');
    el.querySelector('.mg-quit').onclick = () => this._finish(false);

    this.spawnTimer = setInterval(() => this._spawn(), 700);
    this.tickTimer = setInterval(() => this._tick(), 1000);
    this._spawn();
  }

  _spawn(){
    if (this.done) return;
    const b = document.createElement('div');
    b.className = 'blip';
    // random point inside the radar circle (polar for even spread)
    const a = Math.random() * Math.PI * 2;
    const r = Math.sqrt(Math.random()) * 42;         // % radius
    b.style.left = (50 + Math.cos(a) * r) + '%';
    b.style.top = (50 + Math.sin(a) * r) + '%';
    b.onclick = () => {
      if (this.done || !this.blips.has(b)) return;
      this.hits++;
      this.hitsLabel.textContent = `${this.hits} / ${this.target}`;
      this._remove(b);
      if (this.hits >= this.target) this._finish(true);
    };
    this.radar.appendChild(b);
    this.blips.add(b);
    // each blip self-destructs if not tapped in time
    b._life = setTimeout(() => this._remove(b), 1200);
  }

  _remove(b){
    clearTimeout(b._life);
    this.blips.delete(b);
    b.remove();
  }

  _tick(){
    if (this.done) return;
    this.timeLeft--;
    this.timeLabel.textContent = this.timeLeft + 's';
    if (this.timeLeft <= 0) this._finish(this.hits >= this.target);
  }

  _finish(won){
    if (this.done) return;
    this.done = true;
    clearInterval(this.spawnTimer);
    clearInterval(this.tickTimer);
    this.blips.forEach(b => clearTimeout(b._life));
    this.blips.clear();
    const card = this.el.querySelector('.mg-card');
    if (won){
      card.innerHTML = `
        <h2>💎 Radar Crystal Found!</h2>
        <div class="mg-sub">You scanned enough asteroids to pull a radar crystal from the belt.</div>
        <button class="cafe-btn mg-ok">take the crystal</button>`;
      card.querySelector('.mg-ok').onclick = () => { this.unmount(); this.onWin(); };
    } else {
      card.innerHTML = `
        <h2>📡 Signal Lost</h2>
        <div class="mg-sub">Only ${this.hits}/${this.target} scanned. The crystal slipped away — try again!</div>
        <button class="cafe-btn mg-ok">try again</button>
        <button class="cafe-btn ghost mg-close">leave</button>`;
      card.querySelector('.mg-ok').onclick = () => { this.unmount(); const g = new AsteroidRadar({ target: this.target, duration: this.duration, onWin: this.onWin, onClose: this.onClose }); g.mount(); };
      card.querySelector('.mg-close').onclick = () => { this.unmount(); this.onClose(); };
    }
  }

  unmount(){
    clearInterval(this.spawnTimer);
    clearInterval(this.tickTimer);
    this.blips.forEach(b => clearTimeout(b._life));
    this.blips.clear();
    if (this.el){ this.el.remove(); this.el = null; }
  }
}
